import { COLORS } from 'core/constants';
import Copy from '@resn/gozer-core/copy';

const array = (n) => Array.from(new Array(n));

const accessories = {
    wireless: { id: 'accessory-smart-puck', text: Copy.get('xs1-product-module-8-accessory-1') },
    strengthBench: { id: 'accessory-strength-bench', text: Copy.get('xs1-product-module-8-accessory-2') },
    multiFunctionBench: { id: 'accessory-bench', text: Copy.get('xs1-product-module-8-accessory-3') },
    multiBar: { id: 'accessory-multi-function-bar', text: Copy.get('xs1-product-module-8-accessory-13') },
    barbell: { id: 'accessory-barbell', text: Copy.get('xs1-product-module-8-accessory-4') },
    handGrips: { id: 'accessory-hand-grips', text: Copy.get('xs1-product-module-8-accessory-5') },
    rope: { id: 'accessory-rope', text: Copy.get('xs1-product-module-8-accessory-6') },
    harness: { id: 'accessory-waist-harness', text: Copy.get('xs1-product-module-8-accessory-7') },
    ankleStraps: { id: 'accessory-ankle-straps', text: Copy.get('xs1-product-module-8-accessory-8') },
    skicrossHandles: { id: 'accessory-ski-cross-handles', text: Copy.get('xs1-product-module-8-accessory-9') },
    swimPaddles: { id: 'accessory-swim-paddles', text: Copy.get('xs1-product-module-8-accessory-10') },
    adjustablePaddle: { id: 'accessory-paddle', text: Copy.get('xs1-product-module-8-accessory-11') },
    pilates: { id: 'accessory-pilates-reformer-bench', text: Copy.get('xs1-product-module-8-accessory-12') },
    rowBar: { id: 'accessory-row-bar', text: Copy.get('xs1-product-module-8-accessory-14') },
};

const activities = [
    { id: 'weight-training', text: Copy.get('xs1-product-module-8-activity-1') },
    { id: 'skiing', text: Copy.get('xs1-product-module-8-activity-2') },
    { id: 'rowing', text: Copy.get('xs1-product-module-8-activity-3') },
    { id: 'kayaking', text: Copy.get('xs1-product-module-8-activity-4') },
    { id: 'canoeing', text: Copy.get('xs1-product-module-8-activity-5') },
    { id: 'paddleboarding', text: Copy.get('xs1-product-module-8-activity-6') },
    { id: 'swimming', text: Copy.get('xs1-product-module-8-activity-7') },
    { id: 'pilates', text: Copy.get('xs1-product-module-8-activity-8') },
];

export default {
    packages: [
        {
            id: Copy.get('xs1-product-module-8-flex-title'),
            tagline: Copy.get('xs1-product-module-8-flex-subtitle'),
            color: COLORS.ELECTRIC_BLUE,
            types: [
                {
                    title: Copy.get('xs1-product-module-8-flex-title'),
                    description: Copy.get('xs1-product-module-8-flex-subtitle'),
                    // free style features
                    accessories: [
                        accessories.wireless,
                        accessories.strengthBench,
                        accessories.barbell,
                        accessories.handGrips,
                        accessories.rope,
                        accessories.harness,
                        accessories.ankleStraps,
                        accessories.skicrossHandles,
                        accessories.multiBar,
                    ],
                    activities: activities.slice(0, 2),
                    subscriptionsTitle: Copy.get('xs1-product-module-8-flex-subscription-title'),
                    subscriptions: array(5)
                        .map((_, i) => Copy.get(`xs1-product-module-8-flex-subscription-${i + 1}`))
                        .filter((el) => el != ''),
                },
            ],
        },
        {
            id: Copy.get('xs1-product-module-8-flow-title'),
            tagline: Copy.get('xs1-product-module-8-flow-subtitle'),
            color: COLORS.ELECTRIC_BLUE,
            types: [
                {
                    title: Copy.get('xs1-product-module-8-flow-title'),
                    description: Copy.get('xs1-product-module-8-flow-subtitle'),
                    accessories: [
                        accessories.wireless,
                        accessories.multiFunctionBench,
                        accessories.multiBar,
                        accessories.barbell,
                        accessories.handGrips,
                        accessories.rope,
                        accessories.harness,
                        accessories.ankleStraps,
                        accessories.skicrossHandles,
                        accessories.swimPaddles,
                        accessories.adjustablePaddle,
                        accessories.rowBar,
                    ],
                    activities: activities.slice(0, 7),
                    subscriptionsTitle: Copy.get('xs1-product-module-8-flow-subscription-title'),
                    subscriptions: array(5)
                        .map((_, i) => Copy.get(`xs1-product-module-8-flow-subscription-${i + 1}`))
                        .filter((el) => el != ''),
                },
            ],
        },
        {
            id: Copy.get('xs1-product-module-8-peak-title'),
            tagline: Copy.get('xs1-product-module-8-peak-subtitle'),
            color: COLORS.ELECTRIC_BLUE,
            types: [
                {
                    title: Copy.get('xs1-product-module-8-peak-title'),
                    description: Copy.get('xs1-product-module-8-peak-subtitle'),
                    accessories: [
                        accessories.wireless,
                        accessories.multiFunctionBench,
                        accessories.multiBar,
                        accessories.barbell,
                        accessories.handGrips,
                        accessories.rope,
                        accessories.harness,
                        accessories.ankleStraps,
                        accessories.skicrossHandles,
                        accessories.swimPaddles,
                        accessories.adjustablePaddle,
                        accessories.pilates,
                        accessories.rowBar
                    ],
                    activities: activities,
                    subscriptionsTitle: Copy.get('xs1-product-module-8-peak-subscription-title'),
                    subscriptions: array(5)
                        .map((_, i) => Copy.get(`xs1-product-module-8-peak-subscription-${i + 1}`))
                        .filter((el) => el != ''),
                },
            ],
        },
    ],
};
